/* eslint-disable max-lines */
import { Currency, NativeCurrency, Token, WETH9 } from '@uniswap/sdk-core'
import invariant from 'tiny-invariant'
import { UniverseChainId } from 'uniswap/src/features/chains/types'

// WH2 占位符：最小配置，仅用于 SDK 兼容性
// 完整的 WH2 信息将从接口动态获取
const WH2_PLACEHOLDER = new Token(
  UniverseChainId.H2,
  '0x1e69ed5584b562da61c69433b6bb5430f351b1de', // WH2 地址（从接口获知）
  18,
  'WH2',
  'Wrapped H2'
)

export const WRAPPED_NATIVE_CURRENCY: { [chainId: number]: Token } = {
  [UniverseChainId.H2]: WH2_PLACEHOLDER,
}

function isH2(chainId: number): chainId is UniverseChainId.H2 {
  return chainId === UniverseChainId.H2
}

class ExtendedEther extends NativeCurrency {
  public get wrapped(): Token {
    const wrapped = WRAPPED_NATIVE_CURRENCY[this.chainId]
    if (wrapped) {
      return wrapped
    }
    throw new Error(`Unsupported chain ID: ${this.chainId}`)
  }

  protected constructor(chainId: number) {
    // Use H2-specific symbol and name for H2 chain
    if (isH2(chainId)) {
      super(chainId, 18, 'H2', 'H2')
    } else {
      super(chainId, 18, 'ETH', 'Ethereum')
    }
  }

  private static _cachedExtendedEther: { [chainId: number]: NativeCurrency } = {}

  public static onChain(chainId: number): ExtendedEther {
    return this._cachedExtendedEther[chainId] ?? (this._cachedExtendedEther[chainId] = new ExtendedEther(chainId))
  }

  public equals(other: Currency): boolean {
    return other.isNative && other.chainId === this.chainId
  }
}

const cachedNativeCurrency: { [chainId: number]: NativeCurrency | Token } = {}
export function nativeOnChain(chainId: number): NativeCurrency | Token {
  if (cachedNativeCurrency[chainId]) {
    return cachedNativeCurrency[chainId] as NativeCurrency
  }
  let nativeCurrency: NativeCurrency | Token
  if (isH2(chainId)) {
    nativeCurrency = ExtendedEther.onChain(chainId)
  } else {
    throw new Error(`Unsupported chain ID: ${chainId}`)
  }
  return (cachedNativeCurrency[chainId] = nativeCurrency)
}
